import React from 'react';

const AddTextSpaceBelow = ({ lessonText, setLessonText }) => {
  return (
    <textarea
      className="LessonGenerateModal--textarea NewInput NewInput--white NewInput--fw"
      onChange={e => setLessonText(e.target.value)}
      rows="10"
      value={lessonText}
      placeholder={t(
        'actions.lesson_generate_modal.copy_and_paste_placeholder',
      )}
    />
  );
};

export default AddTextSpaceBelow;
